export default __webpack_public_path__ + "static/media/SideBarArrow.43301cf0.svg";